import React from 'react'

interface IProps
  extends React.DetailedHTMLProps<React.HTMLAttributes<HTMLSpanElement>, HTMLSpanElement> {}

export const EditorCommandSpacer = ({ className = 'px-3 pb-0', ...props }: IProps) => (
  <span className={className} {...props}>
    <span className="btn-separator"></span>
  </span>
)
